import type { ApiConfig } from '../../types'

export const futuresChangeHistoryApiConfig = {
  existSubType: true, // settle (btc / usdt)
  fetchableRange: undefined, // 制限なし
  limit: 1000,
  order: 'desc',
  range: (30 * 24 * 60 * 60 - 1) * 1000, // 30 days in milliseconds
  requiresRange: true,
  type: 'futures-change-history',
} as const satisfies ApiConfig
